import classnames from 'classnames';

import type { BlocksWithTicksProps } from './types';

import useStyles from './styles';

const BlocksWithTicksFallback = ({ title, blocks }: BlocksWithTicksProps) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={styles.skeletonWrapper}>
        {title && <i className={classnames(styles.titleSkeleton, 'skeleton')} />}
        <ul className={styles.content}>
          {blocks.map(({ title: subTitle, description }, index) => (
            <li key={index}>
              <div className={styles.benefitItem}>
                <div className={styles.icon}>
                  <i className="skeleton" />
                </div>
                {subTitle && <i className={classnames(styles.subTitleSkeleton, 'skeleton')} />}
                {description && (
                  <i className={classnames(styles.descriptionSkeleton, 'skeleton')} />
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BlocksWithTicksFallback;
